import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted Inter (variable weight axis, ships font-display: swap) so the theme font stack resolves.
import '@fontsource-variable/inter';
import App from './App';
import { initSentry } from './sentry';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
